module.exports = __webpack_public_path__ + "static/media/search-sample-2.bbe1a1e8.png";